import React from 'react'
import { GeoCalligraphy } from '../../component/about/GeoCalligraphy'

export default function GeocalligraphyPage() {
  return (
    <>
      <GeoCalligraphy />
    </>
  )
}
